import {Stack} from "@src/CommonComponents/Stack/Stack.tsx";
import styles from "./workPeriodInfo.module.less"
import {WorkDayWithEvents} from "@src/Store/employeesStore.ts";
import React, {useMemo} from "react";
import {formatMsToJpTime, getCurrentDateStr, strToTime} from "@src/utils/formatDate.ts";
import {
    Body_14_Coral_Primary_Regular_14,
    Body_16_Coral_Strong_emphasis_16
} from "@UI/typography/generated/typography.tsx";
import {Gt} from "@src/i18n/Gt";
import {Sun} from "@UI/components/icons/Sun.tsx";
import cn from "classnames";
import {Checked} from "@UI/components/icons/Checked.tsx";
import {useNetworkWatcher} from "@src/utils/net.ts";
import {Colors} from "@UI/theme/generated/Colors.ts";


const OnlineView = ({workedHoursMS}: {workedHoursMS: number}) => {

    const workedHours = useMemo(() => {
        if (workedHoursMS === 0) return "-"
        return formatMsToJpTime(workedHoursMS)
    }, [workedHoursMS])

    return (
        <Stack direction={"column"} grow justifyContent={"center"} >
            <Body_14_Coral_Primary_Regular_14>
                <Gt>Working hours</Gt>
            </Body_14_Coral_Primary_Regular_14>
            <Stack grow justifyContent={"space-between"}>
                <Body_16_Coral_Strong_emphasis_16>
                    <span
                        className={cn(styles.normalLen)}>
                        {workedHours}
                    </span>
                </Body_16_Coral_Strong_emphasis_16>
                <Stack className={styles.info}>
                    <Checked/>
                    <Body_14_Coral_Primary_Regular_14>
                        <Gt>Including breaks</Gt>
                    </Body_14_Coral_Primary_Regular_14>
                </Stack>
            </Stack>
        </Stack>
    )
}


const OfflineView = () => {
    return (
         <Stack direction={"column"} grow justifyContent={"center"}>
            <Body_14_Coral_Primary_Regular_14>
                <Gt>Working hours</Gt>
            </Body_14_Coral_Primary_Regular_14>
             <Stack grow justifyContent={"space-between"}>
                 <Body_16_Coral_Strong_emphasis_16 style={{color: Colors.Coral_special_Error_red}}>
                     <Gt>Working hours cannot be calculated</Gt>
                 </Body_16_Coral_Strong_emphasis_16>
             </Stack>
        </Stack>
    )
}

export const WorkPeriodInfo = ({workDays, className, style}: {
    workDays: WorkDayWithEvents[],
    style?: React.CSSProperties
    className?: string
}) => {
    const {online} = useNetworkWatcher()

    const {correct, workedHoursMS} = useMemo(() => {
        let correct = true
        let workedHoursMS = 0

        for (const workDay of workDays) {
            if (!workDay.total_time && workDay.date !== getCurrentDateStr()) {
                correct = false
                continue
            }
            workedHoursMS += workDay?.total_time ? strToTime(workDay.total_time) : 0
        }
        return {
            correct,
            workedHoursMS
        }
    }, [workDays]);
    
    return (
        <Stack className={cn(styles.root, className)} direction={"column"} style={style}>
            <Stack alignItems={"center"} gap={16}>
                <Sun />
                {(!online || !correct)
                    ? <OfflineView />
                    : <OnlineView workedHoursMS={workedHoursMS} />
                }
            </Stack>
        </Stack>
    )
}